import { useAppSelector } from '../store';

export function useSessionId(): string {
  const user = useAppSelector((state) => state.auth.user);
  return user?.sessionId ?? '';
}
